import { render, staticRenderFns } from "./layout_v2.vue?vue&type=template&id=4728bc56&"
import script from "./layout_v2.vue?vue&type=script&lang=js&"
export * from "./layout_v2.vue?vue&type=script&lang=js&"
import style0 from "./layout_v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4728bc56')) {
      api.createRecord('4728bc56', component.options)
    } else {
      api.reload('4728bc56', component.options)
    }
    module.hot.accept("./layout_v2.vue?vue&type=template&id=4728bc56&", function () {
      api.rerender('4728bc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/layout_v2.vue"
export default component.exports